import styled from '@emotion/styled'
import { mq } from '../../../helpers'
import { gsColors } from '../../../styles/Variables'

export const AffiliateWrapper = styled.div`
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-x: hidden;

  .hero-component {

    .hero-container-inner {
      ${mq('max', '768px')} {
        height: unset !important;
        height: auto !important;
      }
    }

    .web-header-text {
      ${mq('max', '768px')} {
        display: none;
      }
    }

    .content {
      width: 100%;

      .inner {
        width: 100%;
      }

      button {
        ${mq('max', '768px')} {
          font-size: 16px;
        }
      }

      p {

        ${mq('max', '940px')} {
          font-size: 20px;  
          margin-bottom: 24px;
        }
      }

      h1 {
        ${mq('max', '940px')} {
          font-size: 46px;
        }

        ${mq('max', '821px')} {
          font-size: 42px;
        }
      }
    }
  
    .mobile-header-text {
      display: none;
  
      ${mq('max', '768px')} {
        display: block;
        width: 100% !important;
      }
    }

    .image-placeholder {
      ${mq('max', '768px')} {
        height: 500px !important;
      }

      span {
        img {
          object-position: 100% 50%;

          ${mq('max', '1280px')} {
            object-position: 65% 50%;
          }

          ${mq('max', '1024px')} {
            object-position: 55% 50%;
          }

          ${mq('max', '768px')} {
            object-position: 60% 50%;
          }
        }
      }
    }
  } 
`

export const HowItWorksWrapper = styled.section`
  padding: 68px 88px;
  max-width: 1600px;
  width: 100%;

  ${mq('max', '768px')} {
    padding: 50px 16px;
  }

  .how-content {

    .items-container {
      border-left: 1px solid black;
      margin-top: 54px;
      padding-left: 100px;
      gap: 50px;
      display: flex;
      justify-content: space-between;

      ${mq('max', '768px')} {
        flex-direction: column;
        border: none;
        padding-left: 0;
      }

      .item {
        max-width: 350px;
        display: flex;
        flex-direction: column;
        gap: 12px;

        ${mq('max', '768px')} {
          max-width: 100%;
        }
      }
    }
  }
`

export const WhoWeAreWrapper = styled.section`
  box-sizing: border-box;
  width: 100%;
  max-width: 1600px;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${gsColors.khaki};

  .who-we-are-web {
    height: auto;
    width: 100%;
    padding: 104px 88px 0;
    display: flex;
    flex-direction: row;
    gap: 50px;

    .mobile-header {
      font-size: 25px;
      display: none;
      order: 1;
      ${mq('max', '900px')} {
        display: block;
      }
    }


    ${mq('max', '1200px')} {
      padding: 52px 44px 0;
    }

    ${mq('max', '900px')} {
      flex-direction: column-reverse;
    }

    ${mq('max', '768px')} {
      padding: 50px 16px;
    }

    .left {
      display: flex;
      flex-direction: column;
      height: auto;

      h2 {
        ${mq('max', '1200px')} {
          font-size: 38px;
          margin: 0 0 19px 0 !important;
        }

        ${mq('max', '900px')} {
          display: none;
        }

      }

      .text-container {
        padding: 0 80px;

        ${mq('max', '1280px')} {
          padding: 0 80px 0 0;;
        }

        ${mq('max', '960px')} {
          padding: 0 40px 0 0;;
        }

        p {
          ${mq('max', '1200px')} {
            font-size: 20px;

            &:last-of-type {
              margin: 0 0 30px 0;
            }
          }
        }
      }
        
      .text-container {
        .content {
          max-width: 680px;
        }
        
        a {
          margin: 30px 0 50px 0;
          display: block;
        }
      }
    }

    .right {
      display: flex;
      align-self: flex-end;
      justify-content: flex-end;
      flex: 1;

      ${mq('max', '900px')} {
        width: 100%;
        justify-content: flex-start;
      }

      .photo-booth-image {
        display: flex;
        align-items: flex-end;
        position: relative;
        width: 324px;
        max-height: 100%;
        overflow: hidden;

        ${mq('max', '900px')} {
          width: auto;
          max-height: 300px;
        }

        .image-mobile {
          display: none;
          ${mq('max', '900px')} {
            display: block;
          }
        }

        .image-web {
          display: block;
          ${mq('max', '900px')} {
            display: none;
          }
        }

        img {
          object-fit: cover;
          height: auto;
          width: 100%;
        }
      }
    }
  }
`

export const WhyJoinWrapper = styled.section`
  display: flex;
  position: relative;
  width: 100%;
  max-width: 1600px;
  height: auto;
  background-color: ${gsColors.salmon};

  ${mq('max', '768px')} {
    flex-direction: column;
  }

  .why-content {
    flex: 1;
    box-sizing: border-box;
    display: flex;
    flex-basis: 50%;
    flex-direction: column;
    align-items: flex-start;
    padding: 90px;

    ${mq('max', '1024px')} {
      flex-basis: 70%;
    }

    ${mq('max', '768px')} {
      padding: 44px 16px;
      order: 2;
      flex-basis: 100%;
    }

    .list {
      display: flex;
      flex-direction: column;
      gap: 32px;


      .list-item {
        display: flex;
        flex-direction: row;
        align-items: center;

        .check-box {
          height: 40px;
          width: 40px;
          aspect-ratio: 1/1;
          background-color: ${gsColors.cobalt};
          display: flex;
          justify-content: center;
          align-items: center;

          ${mq('max', '768px')} {
            height: 30px;
            width: 30px;

            img {
              height: 30px;
              width: 30px;
            }
          }
        }

        p {
          max-width: 600px;

          ${mq('max', '768px')} {
            margin-left: 40px !important;
          }
        }
      }
    }

    button {

      ${mq('max', '768px')} {
        font-size: 16px;
      }
    }
  }

  .image-placeholder {
    position: relative;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-basis: 50%;

    ${mq('max', '1024px')} {
      flex-basis: 30%;
    }

    ${mq('max', '768px')} {
      height: 395px;
      // aspect-ratio: 1;
      flex: none
    }
  }
`

export const QuestionsWrapper = styled.section`
  box-sizing: border-box;
  width: 100%;
  max-width: 1600px;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 88px 88px 0;

  ${mq('max', '768px')} {
    padding: 44px 16px 0;
  }

  p {
    display: inline-block;
    text-align: center;
    margin-bottom: 88px;

    ${mq('max', '768px')} {
      flex-direction: column;
      gap: 8px;

      a, p {
        font-size: 18px;
      }
    }

    a {
      font-size: 18px;
      color: #000;
      font-weight: 700;
      transform: translateY(2px);

      &:visited {
        color: #000;
      }
    }
  }

  .please-note {
    border-top: 1px solid #000;
    border-bottom: 1px solid #000;
    padding: 67px 0;

    ${mq('max', '768px')} {
      padding: 32px 16px;
    }

    p {
      margin: 0;
    }
  }
`
